import React from 'react';
import { NavLink } from 'react-router-dom';
import logo from "../../asset/janpravah_logo.png";

const Navbar = () => {

  const closeNavbar = () => {
    const navbar = document.getElementById('navbarNav');
    if (navbar.classList.contains('show')) {
      navbar.classList.remove('show');
    }

    // Also close open dropdowns if any (optional)
    const dropdowns = document.querySelectorAll('.dropdown-menu.show');
    dropdowns.forEach(menu => menu.classList.remove('show'));
  };

  return (
    <nav className="navbar navbar-expand-lg shadow">
      <div className="container">
        <img src={logo} alt="Logo" className="logo" />
        <NavLink className="navbar-brand" to="/">JANPRAVAHA SOCIAL FOUNDATION</NavLink>

        <button
          className="navbar-toggler"
          type="button"
          data-bs-toggle="collapse"
          data-bs-target="#navbarNav"
        >
          <span className="navbar-toggler-icon"></span>
        </button>

        <div className="collapse navbar-collapse" id="navbarNav">
          <ul className="navbar-nav ms-auto">
            <li className="nav-item">
              <NavLink className="nav-link" to="/" end onClick={closeNavbar}>Home</NavLink>
            </li>

            <li className="nav-item dropdown">
              <a
                className="nav-link dropdown-toggle"
                href="#"
                role="button"
                data-bs-toggle="dropdown"
                aria-expanded="false"
              >
                About Us
              </a>
              <ul className="dropdown-menu">
                <li>
                  <NavLink className="dropdown-item" to="/about" onClick={closeNavbar}>
                    About Us
                  </NavLink>
                </li>
                <li>
                  <NavLink className="dropdown-item" to="/founder" onClick={closeNavbar}>
                    Our Team
                  </NavLink>
                </li>
              </ul>
            </li>

            <li className="nav-item">
              <NavLink className="nav-link" to="/our-work" onClick={closeNavbar}>Our Work</NavLink>
            </li>
            <li className="nav-item">
              <NavLink className="nav-link" to="/gallery" onClick={closeNavbar}>Gallery</NavLink>
            </li>
            <li className="nav-item">
              <NavLink className="nav-link" to="/contact" onClick={closeNavbar}>Contact</NavLink>
            </li>
          </ul>
        </div>
      </div>
    </nav>
  );
};

export default Navbar;
